<li>
    <a href="#" class="{{{ o.value }}}" data-value="{{{ o.value }}}">
        <span class="icon-{{{ o.value }}}"></span>
        {{{ o.text }}}
    </a>
</li>
